import script from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayout.vue?vue&type=style&index=0&id=5f6597ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6597ae"]])

export default __exports__